import { render, staticRenderFns } from "./EventEntriesForm.vue?vue&type=template&id=5bfaf540&scoped=true&"
import script from "./EventEntriesForm.vue?vue&type=script&lang=js&"
export * from "./EventEntriesForm.vue?vue&type=script&lang=js&"
import style0 from "./EventEntriesForm.vue?vue&type=style&index=0&id=5bfaf540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfaf540",
  null
  
)

export default component.exports